module.exports = __webpack_public_path__ + "static/media/pfizer.10a68b37.png";